define([
    '../Util/freezeObject'
], function (
    freezeObject) {
    'use strict'

    /**
     * 文字、图标的对齐方式。
     *
     * @exports EnumAlignmentMode
     * 
     * @see IconSymbol#alignMode
     * @see TextSymbol#alignMode
     */
    var EnumAlignmentMode = {
        /**
         * 九宫格的左上格。
         * @type {Number}
         * @constant
         */
        LEFT_TOP: 0,

        /**
         * 九宫格的左中格。
         * @type {Number}
         * @constant
         */
        LEFT_CENTER: 1,

        /**
         * 九宫格的左下格。
         * @type {Number}
         * @constant
         */
        LEFT_BOTTOM: 2,

        /**
         * 九宫格的中上格。
         * @type {Number}
         * @constant
         */
        CENTER_TOP: 3,

        /**
         * 九宫格的中心格。
         * @type {Number}
         * @constant
         */
        CENTER_CENTER: 4,

        /**
         * 九宫格的中下格。
         * @type {Number}
         * @constant
         */
        CENTER_BOTTOM: 5,

        /**
         * 九宫格的右上格。
         * @type {Number}
         * @constant
         */
        RIGHT_TOP: 6,

        /**
         * 九宫格的右中格。
         * @type {Number}
         * @constant
         */
        RIGHT_CENTER: 7,

        /**
         * 九宫格的右下格。
         * @type {Number}
         * @constant
         */
        RIGHT_BOTTOM: 8
    }
    freezeObject(EnumAlignmentMode)

    /**
     * 反向查找对齐方式的名称。
     * 
     * @param {Number} value 对齐方式的数值。
     * @returns {String} 对齐方式的名称。
     */
    function getName(value) {
        for (var key in EnumAlignmentMode) {
            if (EnumAlignmentMode.hasOwnProperty(key) && EnumAlignmentMode[key] === value) {
                return key
            }
        }
        return undefined
    }
    
    return {
        LEFT_TOP: 0,
        LEFT_CENTER: 1,
        LEFT_BOTTOM: 2,
        CENTER_TOP: 3,
        CENTER_CENTER: 4,
        CENTER_BOTTOM: 5,
        RIGHT_TOP: 6,
        RIGHT_CENTER: 7,
        RIGHT_BOTTOM: 8,
        getName: getName
    }
})